// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"ff4f7af6","36":"ca47fca5","886":"bfb696f8"}[chunkId] + ".chunk.js";
};